/**
 * @generated SignedSource<<8625e211c7ed87dd1bb6b60eb68c929d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarkAllNotificationsAsReadInput = {
  organizationId: string;
};
export type useMarkNotificationsAsReadAllMutation$variables = {
  input: MarkAllNotificationsAsReadInput;
};
export type useMarkNotificationsAsReadAllMutation$data = {
  readonly response: {
    readonly success: boolean | null;
  };
};
export type useMarkNotificationsAsReadAllMutation = {
  response: useMarkNotificationsAsReadAllMutation$data;
  variables: useMarkNotificationsAsReadAllMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkAllNotificationsAsReadResponse",
    "kind": "LinkedField",
    "name": "markAllNotificationsAsRead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMarkNotificationsAsReadAllMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMarkNotificationsAsReadAllMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "804e796dca1225954aa836aadccbfb3e",
    "id": null,
    "metadata": {},
    "name": "useMarkNotificationsAsReadAllMutation",
    "operationKind": "mutation",
    "text": "mutation useMarkNotificationsAsReadAllMutation(\n  $input: MarkAllNotificationsAsReadInput!\n) {\n  response: markAllNotificationsAsRead(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "313d48ef2f530f9ad717d93d18788713";

export default node;
